import type { LaunchpadSalePoolStatus } from '@api/types/launchpadProjects';
import { LAUNCHPAD_SALE_POOL_STATUS } from '@api/types/launchpadProjects';

export const getIsSaleCompletedPoolStatus = (pool: LaunchpadSalePoolStatus) => {
  return (
    [
      LAUNCHPAD_SALE_POOL_STATUS.SALE_FINISHED,
      LAUNCHPAD_SALE_POOL_STATUS.CLAIMING_ANNOUNCED,
      LAUNCHPAD_SALE_POOL_STATUS.CLAIMING_STARTED,
      LAUNCHPAD_SALE_POOL_STATUS.CLAIMING_FINISHED,
    ] as string[]
  ).includes(pool);
};
